// extracted by mini-css-extract-plugin
export var label = "_jx-2";
export var slideContainer = "_jx-0";
export var slider = "_jx-1";